import CsDropDown from './CsDropDown.vue'
CsDropDown.install = function (Vue) {
  Vue.component(CsDropDown.name, CsDropDown)
}
export default CsDropDown


// WEBPACK FOOTER //
// ./src/components/dropdown/index.js